import { Box } from '@mui/material'
import { AppointmentProfile } from 'src/types'

interface OfferingMarketingServiceLineProps {
    offering: AppointmentProfile
}

const OfferingMarketingServiceLine = ({
    offering
}: OfferingMarketingServiceLineProps) => {
    return (
        <Box
            sx={{
                textTransform: 'uppercase',
                fontSize: '12px',
                lineHeight: 1.3,
                pb: 0.5
            }}
        >
            {offering.marketingServiceLines?.at(0)?.label}
        </Box>
    )
}

export default OfferingMarketingServiceLine
